import { formatDate, parseString } from './helpers'

export interface WarehouseInterface {
  id: string
  code: string
  title: string
  description: string
  created_at: string | null
  updated_at: string | null
  deleted_at: string | null
}

export interface WarehouseResponseInterface {
  id: string
  code: string
  title: string
  description: string
  created_at: string | null
  updated_at: string | null
  deleted_at: string | null
}

export function parseWarehouseModel(response: WarehouseResponseInterface): WarehouseInterface {
  return {
    id: parseString(response?.id),
    code: parseString(response?.code),
    title: parseString(response?.title),
    description: parseString(response?.description),
    created_at: formatDate(response?.created_at) || null,
    updated_at: formatDate(response?.updated_at) || null,
    deleted_at: formatDate(response?.deleted_at) || null,
  }
}
